export default "__VITE_ASSET__Ct0pcIg4__"